<template>
  <v-chip
    @click="$emit('action')"
    :color="isRemoval ? 'red' : 'green'"
    :append-icon="isRemoval ? 'mdi-book-minus' : 'mdi-book-plus'"
  >
    <v-btn variant="text" :loading="loading">
      <template v-if="isRemoval"> Remove From Cart {{ personName }} </template>
      <template v-else> Add To Cart - {{ personName }} </template>
      <template v-if="!isRemoval && !!priceCents">
        {{ formatRawCost(priceCents) }}
      </template>
      <span
        v-if="expiresOn"
        :class="
          countdown.isUrgent.value
            ? 'ml-2 text-error font-weight-bold'
            : 'ml-2 text-warning'
        "
      >
        ({{ countdown.timeRemaining.value }})
      </span>
    </v-btn>
  </v-chip>
</template>

<script setup lang="ts">
import { useCountdown } from "@/composables/useCountdown";
import { useUtility } from "@/composables/useUtility";

const { formatRawCost } = useUtility();

const props = defineProps<{
  personName: string | undefined;
  expiresOn: Date | undefined | null;
  loading: boolean;
  isRemoval: boolean;
  priceCents?: number | null;
}>();

defineEmits<{
  action: [];
}>();

const countdown = useCountdown(props.expiresOn || undefined);
</script>
